export interface ICreditCard {
	creditCardType: CreditCardType;
	expiryDate: ICreditCardExpiryDate;
}

export enum CreditCardType {
	AmericanExpress = 'AMEX',
	Visa = 'VISA',
	Mastercard = 'MASTERCARD',
	Discover = 'DISCOVER',
}

export interface ICreditCardExpiryDate {
	/** MM */
	month: string;
	/** YY */
	year: string;
}
